import { UNIFORM_SIZE } from './createUniforms.ts';
import { CLEAR_COLOR } from '../app/config.ts';

export interface RendererDeps {
  device: GPUDevice;
  context: GPUCanvasContext;
  pipeline: GPURenderPipeline;
  bindGroup: GPUBindGroup;
  uniformBuffer: GPUBuffer;
}

export function createRenderer(deps: RendererDeps) {
  const { device, context, pipeline, bindGroup, uniformBuffer } = deps;
  const uniformData = new Float32Array(UNIFORM_SIZE / 4);

  return {
    render(time: number, width: number, height: number, frame: number) {
      uniformData[0] = time;
      uniformData[1] = width;
      uniformData[2] = height;
      uniformData[3] = frame;
      device.queue.writeBuffer(uniformBuffer, 0, uniformData);

      const textureView = context.getCurrentTexture().createView();

      const encoder = device.createCommandEncoder();
      const pass = encoder.beginRenderPass({
        colorAttachments: [
          {
            view: textureView,
            clearValue: CLEAR_COLOR,
            loadOp: 'clear',
            storeOp: 'store',
          },
        ],
      });

      pass.setPipeline(pipeline);
      pass.setBindGroup(0, bindGroup);
      pass.draw(3); // fullscreen triangle
      pass.end();

      device.queue.submit([encoder.finish()]);
    },
  };
}
